module.exports = __webpack_public_path__ + "img/9791159922589.4fc4f1f9.jpg";